import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { XCircle, CheckCircle2 } from 'lucide-react';
const comparisons = [{
  bad: 'Sin protocolo ante riesgo suicida en adolescente: improvisás bajo presión',
  good: 'Protocolo paso a paso y checklist de evaluación de riesgo suicida'
}, {
  bad: 'Sin saber quién tiene autoridad legal para consentir el tratamiento del menor',
  good: 'Guía clara sobre capacidad progresiva y consentimiento según edad'
}, {
  bad: 'No sabés qué hacer cuando el menor revela abuso y el abusador es el progenitor que lo trae a consulta',
  good: 'Protocolo de actuación y denuncia que protege al menor y te blinda'
}, {
  bad: 'Sin plantillas de informe para juzgado de familia: redactás desde cero bajo presión',
  good: 'Plantillas listas para completar adaptadas al sistema judicial'
}, {
  bad: 'No sabés qué psicofármaco prescribir en menores sin exponerte legalmente',
  good: 'Guía de farmacoterapia pediátrica con aval legal y clínico'
}, {
  bad: 'Sin protocolo de denuncia obligatoria claro: el miedo te paraliza y el menor queda desprotegido',
  good: 'Paso a paso para denuncia obligatoria sin contaminar la prueba'
}, {
  bad: 'Documentación incompleta en paciente menor = exposición legal máxima',
  good: 'Modelos de historia clínica y evolución que construyen tu escudo legal'
}, {
  bad: 'Sin sistema de coordinación institucional: escuela, juzgado y familia te consumen el doble del tiempo',
  good: 'Scripts y modelos de comunicación para coordinar la red eficientemente'
}];
export function CostComparison() {
  const [activeTab, setActiveTab] = useState<'bad' | 'good'>('bad');
  return <SectionWrapper data-id="element-68">
      <div className="text-center mb-6 md:mb-10" data-id="element-69">
        <p className="text-orange-600 font-bold tracking-wider text-[10px] md:text-xs uppercase mb-2 md:mb-3" data-id="element-70">
          LA REALIDAD
        </p>
        <h2 className="text-[22px] md:text-3xl font-extrabold text-[#0a1f44] mb-2 md:mb-4 tracking-tight" data-id="element-71">
          ¿Cuánto cuesta NO tenerlo?
        </h2>
      </div>

      {/* Mobile Tabs */}
      <div className="md:hidden flex bg-slate-100 rounded-xl p-1 mb-4 ring-1 ring-slate-900/5" data-id="element-72">
        <button onClick={() => setActiveTab('bad')} className={`flex-1 py-2.5 text-[13px] font-bold rounded-lg transition-all ${activeTab === 'bad' ? 'bg-white text-red-600 shadow-sm ring-1 ring-slate-900/5' : 'text-slate-500'}`} data-id="element-73">
          ❌ Sin Megapack
        </button>
        <button onClick={() => setActiveTab('good')} className={`flex-1 py-2.5 text-[13px] font-bold rounded-lg transition-all ${activeTab === 'good' ? 'bg-white text-emerald-600 shadow-sm ring-1 ring-slate-900/5' : 'text-slate-500'}`} data-id="element-74">
          ✅ Con Megapack
        </button>
      </div>
      <p className="md:hidden text-center text-[11px] text-slate-400 mb-5 font-medium uppercase tracking-wide" data-id="element-75">
        Tocá las pestañas para comparar
      </p>

      {/* Desktop Header */}
      <div className="hidden md:grid grid-cols-2 gap-6 mb-6" data-id="element-76">
        <div className="bg-red-50 text-red-700 font-bold text-lg py-4 px-6 rounded-xl text-center border border-red-100 shadow-sm" data-id="element-77">
          ❌ Sin Megapack
        </div>
        <div className="bg-emerald-50 text-emerald-700 font-bold text-lg py-4 px-6 rounded-xl text-center border border-emerald-100 shadow-sm" data-id="element-78">
          ✅ Con Megapack
        </div>
      </div>

      <div className="space-y-2.5 md:space-y-4" data-id="element-79">
        {comparisons.map((comp, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2 gap-2.5 md:gap-6" data-id="element-80">
            <div className={`bg-white border border-slate-100 rounded-xl p-3.5 md:p-5 flex items-start gap-3 shadow-sm ring-1 ring-slate-900/5 ${activeTab === 'good' ? 'hidden md:flex' : 'flex'}`} data-id="element-81">
              <XCircle className="w-4 h-4 md:w-5 md:h-5 text-red-500 shrink-0 mt-0.5" data-id="element-82" />
              <p className="text-slate-700 text-[13px] md:text-sm leading-relaxed" data-id="element-83">
                {comp.bad}
              </p>
            </div>
            <div className={`bg-emerald-50/40 border border-emerald-100 rounded-xl p-3.5 md:p-5 flex items-start gap-3 shadow-sm ring-1 ring-emerald-900/5 ${activeTab === 'bad' ? 'hidden md:flex' : 'flex'}`} data-id="element-84">
              <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-85" />
              <p className="text-slate-800 font-medium text-[13px] md:text-sm leading-relaxed" data-id="element-86">
                {comp.good}
              </p>
            </div>
          </div>)}
      </div>
    </SectionWrapper>;
}